export default __webpack_public_path__ + "static/media/likeIcon.47ac5392.png";